
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'UrethralTumor_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Urology/UrethralTumor_TNM.vue